import React, { Component } from 'react';
import classnames from 'classnames';
import {Col, Row} from 'react-bootstrap';
import _ from 'underscore';

class SearchSidebarView extends Component {

    componentDidMount() {
        this.debouncedHandleChange = _.debounce((event) => {
            this.props.handleChange({q: event.target.value});
        }, 500);
    }

    handleChange = (event) => {
        event.persist();
        this.debouncedHandleChange(event);
    }

    blurInput() {
        this.refs.input.blur();
    }

    render() {
        return (
            <Row>
                <Col xs={12} className="form-group">
                    <span className="community-sidebar-input-title">{this.props.name}</span>
                </Col>
                <Col xs={12} className="form-group">
                    <input ref="input"
                        type="search"
                        className="form-control"
                        onChange={this.handleChange}
                        placeholder={this.props.placeHolder}
                        defaultValue={this.props.defaultValue}/>
                </Col>
            </Row>
        );
    }
}

export default SearchSidebarView;


